module.exports = __webpack_public_path__ + "img/img4.bf95c643.jpg";